import React from 'react'
import BasePopup from '../Popup'
import styled from "styled-components";
import ImgChangeCoin from '../../../../../assets/images/Event-2026/change-coin.png';
import ImgCongrat from '../../../../../assets/images/Event-2026/congrats-ribbonTBN.png';
import ImgExit from '../../../../../assets/images/Event-2026/exit.png';
import ImgChangeBid from '../../../../../assets/images/Event-2026/popup-change-bid.png';
import ImgBackChangeCoin from '../../../../../assets/images/Event-2026/back-change-coin.png';
import ImgCoin from '../../../../../assets/images/Event-2026/popup-coin.png';
import ImgCoinSuper from '../../../../../assets/images/Event-2026/popup-coin-gold.png';
import PATH from '@config/PATH';
import { ID_TAB_MINI_GAME } from 'helper/const';
import { useQuery } from 'react-query';
import { getMiniGameGetMiniGameQuery } from "dataLayer/miniGame";
import { useLocation, useHistory } from "react-router-dom";


// console.log('dataMinigame: ', dataMinigame);

const PopupContent = ({ data, link }) => {
  if (data?.reelAddNormal > 0 && data?.reelAddSuper > 0) {
    return (
      <>
        <p className="text">Has recibido</p>

        <div className="content-text attempts-success">
          
          <p className="high high_super">{data?.reelAddNormal} monedas {data?.reelAddSuper} supermoneda</p>
          <p>de Misiones para ganar monedas -</p>
          <p>{data?.missionName || ""}</p>
          <div className='group_coin'>
            <img src={ImgCoin} alt="" className="img-bid" />
            <img src={ImgCoinSuper} alt="" className="img-bid" />
          </div>
        </div>
        <button onClick={link} className="btn">
          Gana más piezas
        </button>
      </>
    );
  } else if (data?.reelAddNormal > 0 && data?.reelAddSuper == 0) {
    return (
      <>
        <p className="text">Has recibido</p>

        <div className="content-text attempts-success">
          <p className="high">{data?.reelAddNormal} monedas</p>
          <p>de Misiones para ganar monedas -</p>
          <p>{data?.missionName || ""}</p>
          <img src={ImgCoin} alt="" className="img-bid" />
        </div>
        <button onClick={link} className="btn">
          Gana más piezas
        </button>
      </>
    );
  }
};
export default function PopupCompleteMission({
  visible,
  setVisible,
  data
}) {
  const history = useHistory();

  const handleToMinigame = () => {
    history.push(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`);
    setVisible(false); // Nên đóng popup sau khi chuyển trang
  };

  const { data: dataMinigame } = useQuery(getMiniGameGetMiniGameQuery());
  if (!dataMinigame?.is_show) {
    return null;
  }


  return (
    <BasePopup
      visible={visible}
      onCancel={() => setVisible(false)}
      getContainer
    >
      <ChangeCoin>
        <div className="popup-change-coin">
          <div className="exit">
            <img
              src={ImgExit}
              alt=""
              onClick={() => setVisible(false)}
            />
          </div>

          <img
            src={ImgCongrat}
            alt=""
            className="logo-change-coin"
          />

          <PopupContent
            data={data}
            link={handleToMinigame}
          />
        </div>
      </ChangeCoin>
    </BasePopup>
  );
}
const ChangeCoin = styled.div`
  .popup-change-coin{
    position: relative;
    background-image: url(${ImgBackChangeCoin});
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 999999;

    .group_coin{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    @media (min-width: 768px) {
           min-height: 100%;
    }
		.img-bid {
			width: max-content;
			height: auto;
      max-width: 290px;
			object-fit: contain;

			@media (max-width: 768px) {
				max-width: 265px;
			}
		}
    .exit{
      position: absolute;
      top: 2%;
      right: 2%;

      img{
         height: 40px;
        width: 40px;
        object-fit: contain;
        cursor: pointer;
      }
    }

    .content-text p,
    .text{
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 0;
    }
    .logo-change-coin{
      padding-top: 70px;
    }
    .content-text{
      p{
        padding-top: 10px;
      }
     
      .high-1,
      .high{
        font-size: 40px;
        line-height: 40px;
        font-weight: 900;
        margin-bottom: 10px;
        background: linear-gradient(
        180deg,
        #FEFDFA 28%,
        #FED58A 57%,
        #F7CA27 73%,
        #FDF2B5 92%
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      color: transparent;
      filter: drop-shadow(0px 2.07px 0.69px rgba(14, 0, 137, 1));
      }
      .high_super{
        font-size: 26px;
      }
      .high-1{
        font-size: 25px;
        line-height: 30px;
      }
    }

		.attempts-success{
			p{
				padding: 0;
				margin: 0;
				line-height: 18px;
			}
			.img-bid{
				width: max-content;
				height: 130px;
        margin: 20px;
				@media (max-width: 768px) {
					max-width: 100px;
          margin: 0px;
				}
			}
		}
    .btn{

      cursor: pointer;
      border: none;
      outline: none;
      width: calc(100% - 120px);
      max-width: 100%;
      padding: 10px 20px;
      font-size: 16px;
      color: #fff;
      margin: 10px 40px 20px 40px;
      font-weight: 600;
      border-radius: 5px;
      background: linear-gradient(
      180deg,
      rgba(30, 163, 23, 1) 0%,
      rgba(25, 184, 16, 1) 100%
    );
    }
  }
`
